<template>

  <a
    href="javascript:void(0)"
    class="list-group-item list-group-item-action"
    :class="{'list-group-item-secondary': !notification.read}"
    @click="redirect(notification)">
    <div class="feed-item">
      <div class="feed-icon text-secondary">
        

        <div v-if="notification.type === 'task_reminder'">
          <i class="far fa-check-square" />
        </div>
        <div v-if="notification.type === 'requisition_approvalflow_updated'">
          <i class="fas fa-list" />
        </div>
        <div v-if="notification.type === 'requisition_approvalflow_finished'">
          <i class="fas fa-list" />
        </div>
        <div v-if="notification.type === 'evaluation_created'">
          <i class="fas fa-thumbs-up" />
          <i class="fas fa-thumbs-down" />
        </div>
        <div v-if="notification.type === 'intervideo_created'">
          <i class="fas fa-video" />
        </div>
        <div v-if="notification.type === 'questionnaire_created'">
          <i class="fas fa-clipboard" />
        </div>
        <div v-if="notification.type === 'share_candidate_created'">
          <i class="fas fa-share" />
        </div>
        <div v-if="notification.type === 'note_mention'">
          <i class="fas fa-at" />
        </div>
        <div v-if="notification.type === 'note_created'">
          <i class="fas fa-comment-alt" />
        </div>
        <div v-if="notification.type === 'candidate_qualified'">
          <i class="fas fa-redo-alt" />
        </div>
        <div v-if="notification.type === 'candidate_disqualified'">
          <i class="fas fa-ban" />
        </div>
        <div v-if="notification.type === 'joblog_created'">
          <i class="fas fa-thumbtack" />
        </div>
      </div>
      <div class="feed-content">
        <div class="content">
          <div v-html="notification.message"></div>
          <div class="my-3 text-muted">
            {{ notification.body_shurt }}
          </div>
          <div class="mt-2">
            <small>{{ notification.created_at | moment('fromNow', $i18n.locale) }}</small>
          </div>
        </div>
      </div>
    </div>
  </a>

</template>

<script>
export default {
  name: 'NotificationListItem',
  components: {
  },
  props: {
    notification: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  computed: {
    candidateTabsMap () {
      return {
        created_note: 'note',
        created_evaluation: 'evaluation',
        created_questionnaire: 'questionnaire',
        created_intervideo: 'intervideo',
        task_reminder: 'task'
      }
    }
  },
  created () {
  },
  methods: {
    redirect (notification) {
      if (notification.type === 'share_candidate_created') {
        this.$router.push({path: '/config/share-candidate/'})
      } else if (notification.candidate_id) {
        this.$openCandidateModal(notification.candidate_id, {
          candidate_job_id: notification.job_id,
          candidate_tab: this.candidateTabsMap[notification.type]
        })
      } else if (notification.job_id) {
        this.$router.push({path: '/job/' + notification.job_id})
      } else if (notification.requisition_id) {
        this.$router.push({path: '/requisition/' + notification.requisition_id})
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Notification/NotificationListItem.vue